import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const DashboardLoader = () => {
  return (
    <div>
      <div className="grid grid-cols-4 gap-4 mb-4">
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
        <Skeleton height={126} baseColor={brandColors.lightSilver} />
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div className="grid gap-4 col-span-3">
          <Skeleton height={86} baseColor={brandColors.lightSilver} />
          <Skeleton height={86} baseColor={brandColors.lightSilver} />
          <Skeleton height={86} baseColor={brandColors.lightSilver} />
          <Skeleton height={86} baseColor={brandColors.lightSilver} />
          <Skeleton height={86} baseColor={brandColors.lightSilver} />
        </div>
        <div className="grid gap-4">
          <Skeleton height={248} baseColor={brandColors.lightSilver} />
          <Skeleton height={248} baseColor={brandColors.lightSilver} />
        </div>
      </div>
    </div>
  );
};

export default DashboardLoader;
